import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/gospooky.webp';
import screenshot_target from '../../../images/letterfunnel/liamtjoa.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Liam Tjoa"
      firstname="Liam"
      companyname="GoSpooky"
      competition="Somention en We Are Social"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/liamtjoa.js